import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import {
  EventCard,
  type EventCardUser,
} from '@app/components/blocks/event/EventCard'
import { ViewEventModel } from 'functions/app/event/view'
import { pages } from '@app/util/links'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'

export type EventLinkCardProps = {
  slug: string
}

export const EventLinkCard = ({ slug }: EventLinkCardProps) => {
  const eventQuery = useQuery('view-event', { slug })
  const event: ViewEventModel | null = eventQuery.data

  const users: EventCardUser[] = useMemo(
    () =>
      event?.users?.map((u) => ({
        firstName: u.firstName ?? '',
        lastName: u.lastName ?? '',
        avatar: u.avatar?.src ? { src: u.avatar.src } : undefined,
      })) ?? [],
    [event?.users],
  )

  if (!event) {
    return null
  }

  return (
    <EventCard
      title={event.title}
      start={event.start}
      end={event.end}
      image={event.images?.[0]?.src ?? defaultProjectPicture}
      users={users}
      to={pages.event(slug)}
    />
  )
}
